import { StyleSheet } from 'react-native';
import { Device } from 'DeviceUtils';

let baseStyles = {
    optionsContainer: {
        flexDirection: 'column'
    },
    optionsContainerLandscape: {
        flexDirection: 'row'
    },
    radioButtonsContainer: {
        marginHorizontal: 20,
        marginBottom: 30
    },
    buttonsContainer: {
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    buttonsContainerLandscape: {
        flexDirection: 'row-reverse',
        justifyContent: 'space-around'
    },
    button: {
        marginVertical: 5
    },
    buttonSecondary: {
        flex: 1
    },
    buttonPrimary: {
        flex: 1,
        maxWidth:300,
        marginLeft: 10
    }
};

if (Device.isTabletOrWeb) {
    baseStyles = {
        ...baseStyles,
        buttonsContainer: {
            ...baseStyles.buttonsContainer,
            flexDirection: 'row-reverse',
            justifyContent: 'center'
        },
        button: {
            ...baseStyles.button,
            marginLeft: 15,
            minWidth: 0,
            width: 182,
            height: 48,
            paddingHorizontal: 0
        },
        radioButtonsContainer: {
            ...baseStyles.radioButtonsContainer,
            marginBottom: 10
        }
    };
}

export default StyleSheet.create(baseStyles);
